import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import limparUltimosHIstoricosRota from '../../actions/rota/limparUltimosHIstoricosRota';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <div className="lista-eventos titulo">
      <div className="row cabecalho-desktop" style={{ fontWeight: 'bold'}}>
        <div className="col-12 col-sm-12 col-md">Data e Hora</div>
        <div className="col-12 col-sm-12 col-md">Situação</div>
        <div className="col-12 col-sm-12 col-md">Usuário</div>        
        <div className="col-12 col-sm-12 col-md">Prefixo</div>
        <div className="col-12 col-sm-12 col-md">Delimitação</div>        
        <div className="col-12 col-sm-12 col-md">Cidade Origem</div>
        <div className="col-12 col-sm-12 col-md">Cidade Destino</div>
        <div className="col-12 col-sm-12 col-md">Trecho Alternativo</div>
      </div>
    </div>
  );
  

export class ModalHistoricoRota extends Component {    

    fecharModal () {
        $('#modalHistoricoRota')
            .modal('hide');
        $('#modalHistoricoRota')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHIstoricosRota();
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
          return this.props.historicos.map(historico => <div className="lista-eventos" key={`${historico.id}-${historico.dataEvento}`}>
            <div className="row conteudo-desktop">
              <div className="col-12 col-sm-12 col-md">
                <Moment 
                    format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment>
              </div>
              <div className="col-12 col-sm-12 col-md">
                <div id="evento" className="texto">
                  <p>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md">
                <div id="usuario" className="texto">
                  <p>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</p>
                </div>
              </div>              
              <div className="col-12 col-sm-12 col-md">
                <div id="evento" className="texto">
                  <p>{historico.rota.prefixo}</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md">
                <div id="evento" className="texto">
                  <p>{historico.rota.delimitacao}</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md">
                <div id="evento" className="texto">
                  <p>{historico.rota.cidadeOrigem.nomeComUf}</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md">
                <div id="evento" className="texto">
                  <p>{historico.rota.cidadeDestino.nomeComUf}</p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md">
                <div id="evento" className="texto">
                  <p>{historico.rota.opcoesTrechoAlternativo ? 'Sim' : 'Não'}</p>
                </div>
              </div>              
            </div>
          </div>)
        }
        return ''
      }

      render() {
        return (
            <div className="modal fade show" id='modalHistoricoRota' role='dialog'
                aria-labelledby='modalHistoricoRota' aria-hidden='true' data-backdrop='static'>
            <div className={'modal-dialog modal-dialog-centered modal-lg'}>
            <div className="modal-content">
                <div className="modal-header">
                <h5>Histórico Rota {`${this.props.rotaSelecionada ? '- '+this.props.rotaSelecionada.id : ''}`}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <i className="material-icons" onClick={()=> this.fecharModal()}>
                    &#xe5cd;
                    </i>
                </button>
                </div>
                <div className="modal-body">
                    <Cabecalho />
                    {this.exibirHistoricos()}
                </div>
            </div>
            </div>
        </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        rotaSelecionada: state.rotaSelecionada,
        empresaSelecionada: state.empresaSelecionada,
        historicos: state.ultimosHistoricosRota
    }
};

export default connect(mapStateToProps, {
    limparUltimosHIstoricosRota
})(ModalHistoricoRota)